'use strict';

angular.module('myConsultApp')
    .factory('ManageUsersService', function ($resource, ENV, Session) {

      var manageUsersService = {};

      
      manageUsersService.getUsers = function(params) {

        var newUsers = $resource(ENV.apiEndpoint + '/1.0/users/',{},{
          get:{
            headers: { 'Authorization': 'Bearer '+Session.accessToken }
          }
        });

        return newUsers.get(params).$promise.then(function(response) {
          return response;
        });

      };

      manageUsersService.getUsersByUrl = function (url) {

        var newUsers = $resource(url,{},{
          get:{
            headers: { 'Authorization': 'Bearer '+Session.accessToken }
          }
        });

        return newUsers.get().$promise.then(function(response) {
          return response;
        });

      };

      manageUsersService.makeAdmin = function (param) {

        var makeAdmin = $resource(ENV.apiEndpoint + '/1.0/identities/'+param.user_id+'/groups/', {}, {
          save: {
            method: 'PUT',
            headers: { 'Authorization': 'Bearer '+Session.accessToken }
          }
        });

        return makeAdmin.save(param.data).$promise.then(function(response) {
          return response;
        });

      };

      manageUsersService.removeAdmin = function (param) {

        var removeAdmin = $resource(ENV.apiEndpoint + '/1.0/identities/'+param.user_id+'/delete_group/'+param.admin_group+'/', {}, {
          delete: {
            method: 'DELETE',
            headers: { 'Authorization': 'Bearer '+Session.accessToken }
          }
        });

        return removeAdmin.delete().$promise.then(function(response) {
          return response;
        });

      };

      return manageUsersService;

    });